//import unityContentsService from "../../services/unityContentsService";
import { format } from 'date-fns'
import { es, enUS } from 'date-fns/locale'

export const channelOrNetwork = ((content, channels, networks) => {
    const channel = Array.isArray(channels) && !!content?.channels && channels.find((e) => {
        if (!!e.brandPresenceImage) {
            return e.name === (content?.channels[0]?.name)
        }
    })

    const network = Array.isArray(networks) && !!content?.networks && networks.find((element) => {
        return element?.network === content?.networks[0]?.network;
    })

    const srcChannelOrNetwork = !!channel ? channel?.brandPresenceImage?.url : network?.brandPresenceImage?.url;

    return {channel,network,srcChannelOrNetwork};
});


export const getContentsUrlById = (tokenData, id,setTrailerUrlState)=>{
    /*console.log('tokenData, id: ',tokenData, id)
    if(tokenData && id){
        unityContentsService.getContentsUrlById(tokenData, id, {}).then(({result})=>{
            const resultUrl = result?.entitlements?.find((e)=> e.contentType==="video/mp4" )?.url
            setTrailerUrlState(resultUrl);
        }).catch((e)=>{
            console.error(e)
        })       
    }
    return null*/ 
}

export const formatChannelClassName = (channelName) =>
    channelName.toLowerCase().replaceAll(' ', '-');


export const getFormatedDate = ({date, lang, hoursString = 'hr'}) => {
    if(!date){
        return;
    }

    let locale = enUS;

    if(lang === 'es'){
        locale = es;
    }

    return format(new Date(date), `EEEE dd LLL HH:mm '${hoursString}.'`, { locale })
}